/**
 * krpano 封装
 * @constructor
 * @param {string} id - 嵌入播放器的 div id
 * @param {Object} krpano - 原始 krpano 播放器对象
 */
var KrpanoLayerWrapper = /*#__PURE__*/function () {
  function KrpanoLayerWrapper(id, krpano) {
    this.id = id;
    this.krpano = krpano;
    this.init.bind(this).call();
  }

  var _proto = KrpanoLayerWrapper.prototype;

  _proto.init = function init() {
    var _properties,
        _this = this;

    var properties = (_properties = {
      'type': 'type',
      'url': 'url',
      'keep': 'keep',
      'parent': 'parent',
      'visible': 'visible',
      'enabled': 'enabled',
      'handcursor': 'handcursor',
      'cursor': 'cursor',
      'maskchildren': 'maskchildren',
      'scalechildren': 'scalechildren',
      'zorder': 'zorder',
      'capture': 'capture',
      'children': 'children',
      'preload': 'preload',
      'blendmode': 'blendmode',
      'style': 'style',
      'align': 'align',
      'edge': 'edge',
      'safearea': 'safearea',
      'x': 'x',
      'y': 'y',
      'ox': 'ox',
      'oy': 'oy',
      'rotate': 'rotate',
      'width': 'width',
      'height': 'height',
      'scale': 'scale',
      'pixelhittest': 'pixelhittest',
      'smoothing': 'smoothing',
      'accuracy': 'accuracy',
      'alpha': 'alpha',
      'autoalpha': 'autoalpha',
      'usecontentsize': 'usecontentsize',
      'scale9grid': 'scale9grid',
      'crop': 'crop',
      'onovercrop': 'onovercrop',
      'ondowncrop': 'ondowncrop',
      'mask': 'mask',
      'effect': 'effect',
      'bgcolor': 'bgcolor',
      'bgalpha': 'bgalpha',
      'bgborder': 'bgborder',
      'bgroundedge': 'bgroundedge',
      'bgshadow': 'bgshadow',
      'bgcapture': 'bgcapture',
      'html': 'html',
      'css': 'css',
      'autowidth': 'autowidth',
      'autoheight': 'autoheight',
      'vcenter': 'vcenter',
      'padding': 'padding',
      'wordwrap': 'wordwrap',
      'bg': 'bg',
      'background': 'background'
    }, _properties["bgcolor"] = 'bgcolor', _properties['backgroundcolor'] = 'backgroundcolor', _properties["bgalpha"] = 'bgalpha', _properties["bgborder"] = 'bgborder', _properties["bgroundedge"] = 'bgroundedge', _properties["bgshadow"] = 'bgshadow', _properties['txtshadow'] = 'txtshadow', _properties['mergedalpha'] = 'mergedalpha', _properties['interactivecontent'] = 'interactivecontent', _properties['onautosized'] = 'onautosized', _properties['videourl'] = 'videourl', _properties['hotspotID'] = 'hotspotid', _properties);
    var krpano = this.krpano;
    this.properties = {};

    for (var key in properties) {
      if (properties.hasOwnProperty(key)) {
        (function () {
          var property = properties[key];
          Object.defineProperty(_this, key, {
            get: function get() {
              return krpano.get('layer[' + this.id + '].' + property);
            },
            set: function set(value) {
              if (value === undefined || value === null) {
                krpano.set('layer[' + this.id + '].' + property, null);
                return;
              }

              krpano.set('layer[' + this.id + '].' + property, value);
            }
          });
        })();
      }
    }

    ;
    var eventsProperties = {
      'onOver': 'onover',
      'onHover': 'onhover',
      'onOut': 'onout',
      'onDown': 'ondown',
      'onUp': 'onup',
      'onClick': 'onclick',
      'onLoaded': 'onloaded'
    };
    var eventsKey = 'events';
    this[eventsKey] = {
      __playerId: this.krpano.id,
      __id: this.id,
      __callbacks: {}
    };
    var krpano = this.krpano;

    var _loop = function _loop(_key) {
      if (eventsProperties.hasOwnProperty(_key)) {
        var property = eventsProperties[_key];
        Object.defineProperty(_this[eventsKey], _key, {
          get: function get() {
            return this.__callbacks[_key];
          },
          set: function set(value) {
            if (value === undefined || value === null) {
              krpano.set(eventsKey + '.' + property, null);
              return;
            }

            var targetID = krpano.get("layer[" + this.__id + "].hotspotID");

            if (targetID == undefined) {
              targetID = this.__id;
            }

            krpano.set('layer[' + this.__id + ']' + '.' + property, 'jscall(window.players[\'' + this.__playerId + '\'].getLayerById("' + this.__id + '").events.' + _key + '({id:"' + targetID + '"});)');
            this.__callbacks[_key] = value;
          }
        });
      }
    };

    for (var _key in eventsProperties) {
      _loop(_key);
    }
  };

  return KrpanoLayerWrapper;
}();

export { KrpanoLayerWrapper as default };